import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { _SERVEROOT } from 'src/app/routes/server-root';
import { ClientModel } from '../../model/wh/client.service';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(
    public http: HttpClient,
    public model: ClientModel
  ) { }

  public add(){
    return this.http.post(_SERVEROOT,this.model);
  }

  public get(){
    return this.http.get(_SERVEROOT.whclients_get);
  }
}
